import {ProcessStep} from "../interface/ProcessStep.ts";

export const ONBOARDING_STEPS: ProcessStep[] = [
    {number: 1, label: "Select Actions", path: "/onboarding"},
    {number: 2, label: "Select Roles", path: "/onboarding/page-two"},
    {number: 3, label: "Set Up Profile", path: "/onboarding/page-three"},
];


export const SELL_STEPS: ProcessStep[] = [
    {number: 1, label: "Overview", path: "/sell/add"},
    {number: 2, label: "Details", path: "/sell/add/details"},
    {number: 3, label: "Inspection & Recipient Selection", path: "/sell/add/inspection"},
    {number:4,label:"Success",path:"/sell/add/success",hidden:true}
];